import { Slider, styled } from '@mui/material';

const gradient = `linear-gradient(to left,
    red,         /* red */
    orange,      /* orange */
    yellow,      /* yellow */
    green,       /* green */
    #2EBCE9,
    #1C81A2        /* blue */)`;

const GradientSlider = styled(Slider)({
  height: 8,
  '& .MuiSlider-rail': {
    opacity: 1.0,
    background: gradient,
  },
  '& .MuiSlider-track': {
    background: 'transparent',
  },
  '&.Mui-disabled': {
    '& .MuiSlider-thumb': {
      height: 10,
      width: 10,
      top: '8px',
      backgroundColor: 'transparent',
      border: '0px solid transparent',
      borderRadius: 0,
      '&::after': {
        content: '""',
        position: 'absolute',
        top: '50%',
        left: '50%',
        width: 0,
        height: 0,
        borderLeft: '8px solid transparent',
        borderRight: '8px solid transparent',
        borderTop: '8px solid #808080', // Color of the triangle
        transform: 'translate(-50%, -50%)', // Center the triangle
        display: 'block',
      },
    },
  },
  '& .MuiSlider-thumb': {
    height: 24,
    width: 24,
    backgroundColor: '#fff',
    border: '2px solid currentColor',
    '&:focus, &:hover, &.Mui-active, &.Mui-focusVisible': {
      boxShadow: 'inherit',
    },
    '&:before': {
      display: 'none',
    },
  },
});

export const convertDistance = (value, toMiles) => {
  if (toMiles) {
    return (value * 0.621371).toFixed(2);
  }
  return value;
};

export default GradientSlider;
